import { Canvas } from 'fabric';

import { TextEntity } from '../../metaBullets/classes/TextEntity';
import { Marker } from '../../metaBullets/classes/Marker';

/**
 * Пере-связывает TextEntity с их Marker после загрузки из backup (undo/redo)
 *
 * Проблема: При undo/redo объекты загружаются асинхронно, и TextEntity
 * может быть добавлен на canvas РАНЬШЕ своего Marker. В этом случае
 * event 'added' не находит маркер и связь не устанавливается.
 *
 * Решение: После полной загрузки явно пере-связываем все TextEntity с Marker
 */
export function relinkTextEntitiesWithMarkers(canvas: Canvas): void {
  const allObjects = canvas.getObjects();

  // Находим все TextEntity на canvas
  const textEntities = allObjects.filter((obj): obj is TextEntity => TextEntity.isTextEntity(obj));

  // Находим все Marker на canvas
  const markers = allObjects.filter(
    (obj): obj is Marker => obj.type === 'marker' && !!obj.isMarker,
  ) as Marker[];

  if (textEntities.length === 0) {
    return;
  }

  // Для каждой TextEntity ищем её маркеры
  textEntities.forEach((entity) => {
    // Находим все маркеры для этой entity
    const entityMarkers = markers.filter((marker) => marker.entityId === entity.id);

    if (entityMarkers.length === 0) {
      // Нет маркеров - это нормально
      return;
    }

    // Устанавливаем связь для первого маркера (основной маркер)
    const primaryMarker = entityMarkers[0];

    // Устанавливаем связь только если она еще не установлена
    const currentMarker = (entity as unknown as { marker?: Marker }).marker;
    const currentMarkerId = entity.markerId;

    if (!currentMarker || currentMarkerId !== primaryMarker.id) {
      // Устанавливаем связь
      (entity as unknown as { marker: Marker }).marker = primaryMarker;
      entity.markerId = primaryMarker.id;

      // Обновляем позицию маркера
      try {
        entity.updateMarkerPosition?.();
      } catch (error) {
        console.warn('⚠️ Error updating marker position during relink:', {
          entityId: entity.id,
          markerId: primaryMarker.id,
          error,
        });
      }
    }
  });
}
